<template>
  <div class="login-wrap">
    <header>VANS核销管理系统</header>
    <main>
      <el-input v-model="user.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
      <el-input v-model="user.password" placeholder="请输入密码" prefix-icon="el-icon-user" show-password></el-input>
      <el-select v-model="user.type" placeholder="请选择">
        <el-option
          v-for="item in types"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </main>
    <footer>
      <el-button type="primary" @click="handleLogin">登陆</el-button>
    </footer>
  </div>
</template>

<script>
import $ from '@/assets/js/$axios'
import urls from '@/assets/js/urls.js'
export default {
  data () {
    return {
      types: [
        {
          value: '1',
          label: '经销商'
        },
        {
          value: '2',
          label: '门店'
        }
      ],
      user: {
        username: "",
        password: "",
        type: ""
      }
    }
  },
  methods: {
    handleLogin () {
      const that = this;
      $.Axios('post',urls.login,  that.user ,(res)=>{
        if (res.errcode == 0) {
          localStorage.setItem('userName', that.user.username);
          localStorage.setItem('userType', that.user.type);
          that.$router.push({
            path: "/datalist",
            query: {}
          })
        } else {
          that.$message({
            type: 'info',
            message: res.msg || res.errmsg
          });
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .login-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 320px;
    text-align: center;

    header {
      padding: 20px;
      font-size: 16px;
      font-weight: bold;
      color: #666;
    }
    main {
      .el-input,
      .el-select {
        width: 100%;
        margin-bottom: 20px;
      }
    }
    footer {
      .el-button {
        width: 100%;
      }
    }

  }
</style>

